import React from 'react'
import { MenuContainer, VerticalMenuSeparator } from './NavigationMenu.styled'
import IconMenuItem from './IconMenuItem'
import { BoxProps } from '@mui/material'
import withCapabilities from '../../../hoc/withCapabilities'
import { MenuItem as MenuItemType } from '../../../types/menuItem.types'

interface NavigationMenuProps extends BoxProps {
  items: MenuItemType[]
  hasSeparator?: boolean
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({ items, hasSeparator = true, ...props }) => {
  return (
    <MenuContainer {...props}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <IconMenuItem item={item} />
          {index !== items.length - 1 && hasSeparator && <VerticalMenuSeparator />}
        </React.Fragment>
      ))}
    </MenuContainer>
  )
}

export default withCapabilities(NavigationMenu)
